import http from '@/libs/http'
/*
  NOTICE:
  - every action starts with an underscore
*/

const actions: any = {
	//? PROJECTS
	//? PROJECTS

	//? SET PROJECTS
	async _listProjects({ state, dispatch }: any) {
		try {
			// const config = await dispatch("_config")
			// const resp = await axios.get(env.apiUrl + `/api/v1/projects/list`, config)
			// // const projects = resp.data || []
			// // dispatch("_set", ["projects", projects])
			// return resp.data || []
			const resp = await http.getAuth(`/api/v1/projects/list`)
			return resp || []
		} catch (error: any) {
			console.error(error)
			return []
		}
	},

	async _getProject({ state, dispatch }: any, id: string = '') {
		try {
			// const config = await dispatch("_config")
			// const resp = await axios.get(env.apiUrl + `/api/v1/projects/${id}`, config)
			// // console.log(resp.data);
			// return resp.data || []
			const resp = await http.getAuth(`/api/v1/projects/${id}`)
			return resp || {}
		} catch (error: any) {
			console.error(error)
		}
	},

	//? SET PROJECTS
	async _addNewProject({ state, dispatch }: any, data: any) {
		try {
			// const config = await dispatch("_config")
			// const resp = await axios.post(env.apiUrl + `/api/v1/projects/add`, data, config)
			// await dispatch("_initAdmin", [ 'projects' ])
			// return resp.data
			const resp = await http.postAuth(`/api/v1/projects/add`, data)
			await dispatch('_initAdmin', ['projects'])
			return resp || {}
		} catch (error: any) {
			console.error(error)
			throw new Error(error?.response?.data?.msg || error?.response?.data)
		}
	},

	//? DELETE PROJECTS
	async _deleteProject({ state, dispatch }: any, data: any) {
		try {
			// const config = await dispatch("_config")
			// const resp = await axios.post(env.apiUrl + `/api/v1/projects/delete/${data._id}`, data, config)
			// await dispatch("_initAdmin", [ 'projects' ])
			// return resp.data
			const resp = await http.postAuth(`/api/v1/projects/delete/${data._id}`, data)
			await dispatch('_initAdmin', ['projects'])
			return resp || {}
		} catch (error: any) {
			console.error(error)
			throw new Error(error?.response?.data?.msg || error?.response?.data || 'failed to delete project')
		}
	},

	//? UPDATE PROJECTS
	async _updateProject({ state, dispatch }: any, data: any) {
		try {
			// const config = await dispatch("_config")
			// const resp = await axios.post(env.apiUrl + `/api/v1/projects/update/${data._id}`, data, config)
			// await dispatch("_initAdmin", [ 'projects' ])
			// return resp.data
			const resp = await http.postAuth(`/api/v1/projects/update/${data._id}`, data)
			await dispatch('_initAdmin', ['projects'])
			return resp || {}
		} catch (error: any) {
			console.error(error)
			const msg = error.response?.data?.msg || error.response?.data || error.message
			return {}
		}
	},
}

export default actions
